<template>
  <mu-card class="bottom">
    <mu-card-text>
      <div class="v-header">{{$t('message.labelTodaysPrediction')}} <mu-icon value="help"></mu-icon></div>
      <div>{{$t('message.labelTodaysPredictionExplain')}}</div>
    </mu-card-text>
    <mu-card-text>
      <mu-row gutter>
        <mu-col width="50" desktop="50" tablet="50" class="center-text">
          <radial-progress
            mode="duration"
            data-id="radial-loading-1"
            :value="$store.state.cards.sleep.wearable.minutesAwake"
            :outOfValue="$store.state.cards.sleep.wearable.predictions.minutesAwake"
            suffix="min"
            color="#0179d5"
          ></radial-progress>
          <div>{{$t('message.labelTimeAwake')[0].toUpperCase()+$t('message.labelTimeAwake').substr(1)}}</div>
        </mu-col>
        <mu-col  width="50" desktop="50" tablet="50" class="center-text">
          <radial-progress
            mode="duration"
            data-id="radial-loading-3"
            :value="$store.state.cards.sleep.wearable.minutesAsleep"
            :outOfValue="$store.state.cards.sleep.wearable.predictions.minutesAsleep"
            suffix="min"
            color="#89C93B"
          ></radial-progress>
          <div>{{$t('message.labelTimeAsleep')}}</div>
        </mu-col>
      </mu-row>
    </mu-card-text>
  </mu-card>
</template>

<script>
    import RadialProgress from "../../../RadialProgress/RadialProgress";

    export default {
      components: {RadialProgress},
      name: "sleep-visualisation"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SleepVisualisation.vue?3b36038a